import { country } from "iso-3166-2";
import sortBy from "lodash.sortby";

import type { Region } from "./types";

type Subdivision = {
  name: string;
};

type Subdivisions = Record<string, Subdivision | undefined>;

const getRegionsByCountry = (countryCode: string): Region[] => {
  const { sub }: { sub?: Subdivisions } = country(countryCode);

  const subdivisions = sub || {};

  const hasRegions = Object.values(subdivisions).length > 0;

  if (!hasRegions) {
    return [];
  }

  const prefix = `${countryCode}-`;

  const regions: Region[] = Object.entries(subdivisions)
    .filter(([, region]) => !!region)
    .map(([regionCode, region]) => {
      const value = regionCode.replace(prefix, "");
      const { name: label } = region;

      return { value, label };
    });

  const sortedRegions = sortBy(regions, "label");

  return sortedRegions;
};

export default getRegionsByCountry;
